import { select2RequiredSchema, statusSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object, array } from 'yup';

const addContentSchema = object().shape({
    title: stringRequiredSchema,
    consent_form: stringRequiredSchema,
    consent_for: select2RequiredSchema,
    status: statusSchema,
    description: stringRequiredSchema
});

export default addContentSchema;